//changes from haseeb.

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { UsePortalApi } from "../../../utils/UsePortalApi";

export const Timeline = createAsyncThunk(
  "Timeline",
  async (payload, { dispatch, getState }) => {
    try {
      dispatch(gettingGetTimeline(""));
      const response = await UsePortalApi(
        `Patient/Timeline`,
        "Post",
        payload,
        true
      );
      if (response) {
        console.log(response , "response")
        response[0].hasOwnProperty('entry') ? dispatch(gettingGetTimelineSuccess(response[0].entry)) : dispatch(gettingGetTimelineClear())

      } else {
        dispatch(
          gettingGetTimelineFailed(
            response?.errorMessage
          )
        );
      }
    } catch (error) {
      dispatch(gettingGetTimelineFailed(error));
    }
  }
);

const GetTimelineSlice = createSlice({
  name: "Timeline",
  initialState: {
    PatientTimeline: null,
    isGetting: false,
    error: false,
  },
  reducers: {
    gettingGetTimeline: (state, action) => {
      state.PatientTimeline = null;
      state.isGetting = true;
      state.error = false;
    },
    gettingGetTimelineSuccess: (state, action) => {
      state.PatientTimeline = action.payload;
      state.isGetting = false;
      state.error = false;
    },
    gettingGetTimelineFailed: (state, action) => {
      state.PatientTimeline = null;
      state.isGetting = false;
      state.error = true;
    },
    gettingGetTimelineClear: (state, action) => {
      state.PatientTimeline = null;
      state.isGetting = false;
      state.error = false;
    },
  },
});
export const {
  gettingGetTimeline,
  gettingGetTimelineSuccess,
  gettingGetTimelineFailed,
  gettingGetTimelineClear,
} = GetTimelineSlice.actions;
export default GetTimelineSlice.reducer;
